import type { RouteResource } from 'react-resource-router';

import { eocCommonResources, type UserResourceType } from '@atlassian/eoc-resources';

import type { LogsResponseType } from '../../common/utils';
import type { DownloadFileData } from '../download-export-logs-service/endpoints';
import { downloadAuditLogsResource } from '../download-export-logs-service/resources';
import { logsResource } from '../logs/resources';
import type { LogSettingsResponseType } from '../search/endpoints/types';
import { uiSettingsResource } from '../search/resources';

export const resources = (): (
	| RouteResource<LogSettingsResponseType>
	| RouteResource<UserResourceType>
	| RouteResource<LogsResponseType>
)[] => [uiSettingsResource, logsResource, ...eocCommonResources()];

export const downloadResources = (): (
	| RouteResource<string | DownloadFileData>
	| RouteResource<UserResourceType>
)[] => [downloadAuditLogsResource, ...eocCommonResources()];

export { uiSettingsResource, logsResource, downloadAuditLogsResource };
